export default __webpack_public_path__ + "static/media/(28).c898796a.jpeg";